export const LOCAL_STORAGE_KEYS = {
  token: 'app-token',
  currentUserId: 'current-user-id'
}
